import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AngularMaterialModule } from '../material.module';
import { TaskComponent } from './user-dashboard/task/task.component';
import { SuspendComponent } from './user-dashboard/suspend/suspend.component';
import { AdvanceComponent } from './user-dashboard/advance/advance.component';
import { UnadjustedComponent } from './user-dashboard/unadjusted/unadjusted.component';
import { GsaDashboardComponent } from './gsa-dashboard/gsa-dashboard.component';
import { NgChartsModule } from 'ng2-charts';

export const DashboardDefaultRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      title: 'GRT Global Logistics PVT LTD'
    }

  },{
    path: 'gsa',
    component: GsaDashboardComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    NgChartsModule,
    RouterModule.forChild(DashboardDefaultRoutes),
  ],
  declarations: [
    DashboardComponent,
    TaskComponent,
    SuspendComponent,
    AdvanceComponent,
    UnadjustedComponent,
    GsaDashboardComponent
  ],
  exports: [
    TaskComponent,
    SuspendComponent,
    AdvanceComponent,
    UnadjustedComponent
  ]
})
export class DashboardModule { }